import { StyleSheet } from "react-native";
import { resolveAHTextStyle } from "../Text/AHText";
import React, { useEffect, useRef } from "react";
import { useBoxStyle } from "../AHTheme/useBoxStyle";
import { useLayoutContext } from "../LayoutProvider";
import { useScaleFactor } from "../AHScaleFactor";
import { useTheme } from "../AHTheme/AHTheme";
import { AHInputProps } from "../..";

export const WebAutoGrowingTextArea = ({
  textType = "body-big",
  tabIndex,
  ...props
}: AHInputProps) => {
  const sf = useScaleFactor();
  const boxableStyle = useBoxStyle(props);
  const defaultStyle = useBoxStyle({
    space: "medium",
    cornerRadius: "large",
    color: "surface",
  });
  const theme = useTheme();
  const layout = useLayoutContext();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (props.autoFocus) {
      setTimeout(() => {
        ref.current?.focus();
      }, 150);
    }
  }, [props.autoFocus]);

  useEffect(() => {
    if (ref.current) {
      if (ref.current?.textContent !== props.value) {
        ref.current.textContent = props.value ?? "";
      }
    }
  });
  function onBlur(text: string) {
    if (props.value !== text) {
      props.onChangeText?.(text);
    }
  }
  return (
    <div
      {...{ placeholder: props.placeholder }}
      ref={ref}
      contentEditable
      autoCapitalize="none"
      onBlur={(e) => {
        onBlur(
          Array.from(e.currentTarget.childNodes)
            .map((v) => v.textContent ?? "")
            .join("\n")
        );
      }}
      onInput={(e) => {
        props.onChangeText?.(e.currentTarget.textContent ?? "");
      }}
      style={
        StyleSheet.flatten([
          {
            whiteSpace: "pre-wrap",
          },
          boxableStyle,
          resolveAHTextStyle(textType, sf, theme, layout),
          props.defaultStyle ? defaultStyle : undefined,
          props.style,
        ]) as any
      }
    />
  );
};
